import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ISearchOrderShipmentsOptions } from "../interfaces";
import { searchOrderShipments } from "../services/http-service";

export const useSearchOrderShipments = ({
  searchOptions,
  enabled,
}: {
  searchOptions: ISearchOrderShipmentsOptions;
  enabled: boolean;
}) => {
  const {
    isLoading: loadingSearchOrderShipments,
    isFetching: fetchingSearchOrderShipments,
    isError: errorFetchingSearchOrderShipments,
    data: searchOrderShipmentsResponse,
    error: errorResponse,
    refetch: refetchSearchOrderShipments,
  } = useQuery({
    queryKey: ["searchOrderShipments"],
    queryFn: async () => await searchOrderShipments(searchOptions),
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });
  const fetchSearchOrderShipmentsError = (errorResponse as AxiosError)?.response?.data;

  return {
    loadingSearchOrderShipments,
    fetchingSearchOrderShipments,
    errorFetchingSearchOrderShipments,
    searchOrderShipmentsResponse,
    fetchSearchOrderShipmentsError,
    refetchSearchOrderShipments,
  };
};
